import React from 'react';
import { Link } from 'react-router-dom';

class ChallengeRealDataResults extends React.Component {
    constructor(props){
        super(props)
        this.state = {  dataList:[],
                        dataset:"NPC-A647",
                        softwareSelected:null}

        this.fetchData.bind(this)
        this.renderCard.bind(this)
        this.renderDetails.bind(this)
    }
    componentDidMount(){
        this.fetchData()
    }
    // fetch the list of jsons from server
    fetchData(){
        fetch('/api/getRealDatasetResults',
        {
            method: 'get',
            headers: {"Accept": "application/text"},
            mode: 'same-origin',
        }).then (response => {
            if (response.ok) {
                response.json().then(dataList => {
                    console.log(dataList)
                    this.setState({dataList:dataList["softwareList"],
                                    softwareSelected:dataList["softwareList"][0]["softwareName"]})
                })
            }
        })
    }
    renderCard(software,urls) {
        let url_xy = urls.find( url => url.includes("_icon_xy.png"))
        let url_xz = urls.find( url => url.includes("_icon_xz.png"))
        return ( 
                <a onClick={() => this.setState({softwareSelected:software})}
                    id={software}
                   onMouseEnter={()=> document.getElementById(software).style.backgroundColor = "#ccc"}
                   onMouseLeave={()=> document.getElementById(software).style.backgroundColor = "#fff"}
                 style={{maxWidth:"350px",margin:"4px",cursor:"pointer"}} >
                    <img src={"/challenge_results" +url_xy} className="img-fluid" style ={{margin:"4px"}} title="" alt="" />
                    <img src={"/challenge_results" +url_xz} className="img-fluid" style ={{margin:"4px"}} title="" alt="" />
                    <div className="card-body" style={{justifyContent:"center"}}>
                        <h6 >{software}</h6>
                    </div>
                </a>
        );
    }

    renderDetails(results){
        // urls is the list of all *.png in challenge_results/softwareName/dataset/ folder
        if (typeof results !== 'undefined'){
        let url_bigFOV = results[this.state.dataset].find( url => url.includes("largeFOV_xy"))
        let url_zoom = results[this.state.dataset].find( url => url.includes("FOV1_xy"))
        let url_profile1 = results["Tubulin-A647"].find( url => url.includes("profile1"))
        let url_profile2 = results["Tubulin-A647"].find( url => url.includes("profile2"))
        let url_profile3 = results["Tubulin-A647"].find( url => url.includes("profile3"))
        let url_profile4 = results["Tubulin-A647"].find( url => url.includes("profile4"))
        let url_profile5 = results["Tubulin-A647"].find( url => url.includes("profile5"))
        return (
            <div>
                <div style={{display:"flex"}}>
                    <div style={{width:"1000px",height:"1000px"}}>
                        <img src={"/challenge_results"+ url_bigFOV}  className="img-fluid" ></img>
                    </div>
                    <div style={{margin:"4px"}}>
                        <div style={{display:"flex",margin:"4px"}}>
                            <img style={{marginRight:"5px"}} src={"/challenge_results"+ url_profile1}  className="img-fluid" ></img>
                            <img style={{marginRight:"5px"}} src={"/challenge_results"+ url_profile2}  className="img-fluid" ></img>
                            <img style={{marginRight:"5px"}} src={"/challenge_results"+ url_profile3}  className="img-fluid" ></img>
                            <img style={{marginRight:"5px"}} src={"/challenge_results"+ url_profile4}  className="img-fluid" ></img>
                            <img style={{marginRight:"5px"}} src={"/challenge_results"+ url_profile5}  className="img-fluid" ></img>
                        </div>
                        <img style={{height:"620px",width:"620px",margin:"4px"}} src={"/challenge_results"+ url_zoom}  className="img-fluid" ></img>
                    </div>
                </div>

            </div>
            
        )
    }
    }

    render() {
        return (
        <div>
            <h1>Real datasets results showcase</h1>
            <div style={{display:"flex"}}>
                <div style={{margin:"10px"}}>
                    <button className="btn btn-primary" onClick={()=>this.setState({dataset:"NPC-A647"})}> Display Nuclear pore complexes results </button>
                    <div><Link to="/DatasetPage?name=NPC-A647-3D">Dataset information</Link></div>
                </div>
                <div style={{margin:"10px"}}>
                    <button className="btn btn-primary" onClick={()=>this.setState({dataset:"Tubulin-A647"})}> Display Tubulin results </button>
                    <div><Link to="/DatasetPage?name=Tubulin-A647-3D">Dataset information</Link></div>
                </div>
            </div>
            <hr></hr>

            <h5>Click on the icons to select the software.</h5>
            <div style={{display:"flex"}}>
                {this.state.dataList.map(data => 
                        this.renderCard(data["softwareName"],data[this.state.dataset]))
                }
            </div>
            <h3>Details for {this.state.softwareSelected} / {this.state.dataset}</h3>
            {this.renderDetails(this.state.dataList.find(data => data["softwareName"] === this.state.softwareSelected))}
        </div>
      );
    }
}

export default ChallengeRealDataResults;